import { useCurrentBrandQuery } from "@sol/sdk/current-brand";
import { DoubleArrow } from "@sol/uikit/core/icons/DoubleArrow";
import { SideBarLogo } from "@sol/uikit/core/icons/SideBarLogo";
import { Button } from "@sol/uikit/general/Button/Button";

type Props = {
    menuState: "collapsed" | "overlay" | "fixed";
    onToggleCollapsed: () => void;
};

export const SidebarLogo = ({ menuState, onToggleCollapsed }: Props) => {
    const isCollapsed = menuState === "collapsed";
    const { data: currentBrand } = useCurrentBrandQuery({});
    const brandLogo = currentBrand?.brand?.logo;

    return (
        <div className="relative flex flex-row items-center gap-ant-xs px-ant">
            <div className="flex h-ant-control flex-1 justify-center">
                {brandLogo && !isCollapsed ? (
                    <img src={brandLogo} alt="" className="h-full shrink-0 object-contain" />
                ) : (
                    <SideBarLogo className="h-full shrink-0" isCollapsed={isCollapsed} />
                )}
            </div>

            {!isCollapsed ? (
                <Button
                    onClick={onToggleCollapsed}
                    className="inline-flex size-5 items-center justify-center p-0.5 text-color-ant-primary"
                >
                    <DoubleArrow direction={menuState !== "fixed" ? "right" : "left"} />
                </Button>
            ) : null}
        </div>
    );
};
